module.exports = __webpack_public_path__ + "img/adulto26.bf7fe112.jpg";